import moment from "moment";

// Debounce function to create closure around the function
const debounce = (func, delay) => {
  let debounceTimer;
  return function () {
    const context = this;
    const args = arguments;
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(() => func.apply(context, args), delay);
  };
};
// Greetings function to Greet the user
const greetingFunction = () => {
  var myDate = new Date();
  var hrs = myDate.getHours();

  let greet = "";

  if (hrs < 12){
     greet = 'Good Morning, ';
  }else if (hrs >= 12 && hrs <= 17){
    greet = 'Good Afternoon, ';
  }else if (hrs >= 17 && hrs <= 24){
   greet = 'Good Evening, ';
  }
  return greet
}

const capitalize = (val) => {
  const valString = val.toString();

  if(valString.length){
    const result = valString.charAt(0).toUpperCase() + valString.slice(1);
    return result
  }
}

const downloadFile = (fileUrl, fileName) => {
  const a = document.createElement('a');
  a.href = fileUrl;
  a.download = fileName
  document.body.appendChild(a);
  a.click();
  window.URL.revokeObjectURL(fileUrl);
  // alert('your file has downloaded!'); // or you know, something with better UX...
  document.body.removeChild(a);
}

// amount masking
 const amountMask = (input) => {
  const amount = input ? parseFloat(input.replace(/[^0-9.-]+/g,"")) : ""

  const formattedAmount = amount.toLocaleString('en-US', { style: 'currency', currency: 'USD' });
  
  return formattedAmount
}

// amount mask
const amountMask1 = (input=0, currencySign, precision) => {
  let valSign = '';
  const amount = input === 0 ? "0.00" : input === null ? "0.00" : typeof input === "string" ? input : toFixedNoRound(input, precision? precision: 2);
  // extract '-' sign if it has been entered.
  valSign = amount?.slice(0, 1) === '-' ? amount.slice(0, 1): '';
  if(valSign){
    return `${valSign}${currencySign ?? ''}${amount.toString().slice(1).replace(/\B(?=(\d{3})+(?!\d))/g, ',')}`;
  }
  return `${valSign}${currencySign ?? ''}${amount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}`;
};

 const amountFormat = (input) => {
  const amount = (input === 0 || input === undefined || input === null) ? "0.00" : input
  return amount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
}

const toFixedNoRound = (number, precision) =>{
  if(number%1 === 0){
    return number.toFixed(precision);
  }
  const factor = Math.pow(10, precision);
  const num = Math.floor(number * factor)/factor
  return num.toFixed(2)
}

export const amountHelperMaskFunc = (input) => {
  const amount = input === 0 ? "0.00" : input === null ? "0.00" : typeof input === "string" ? input : toFixedNoRound(input, 2);
  return amount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
};

const formatAmount = (amount) => {
  // const suffixes = ['', 'k', 'm', 'b', 't', ];
  // let suffixIndex = 0;

  // convert if amount equals 1M 
  // while (amount >= 100000000 && suffixIndex < suffixes.length - 1) {
  //   amount /= 1000;
  //   suffixIndex++;
  // }

  // Use the toFixed() method to round the amount to two decimal places
  const formattedAmount = amountHelperMaskFunc(amount ?? 0.00);

  return formattedAmount;
  // return `${formattedAmount} ${suffixes[suffixIndex]}`;
}

const formatDate = (dateVal, format, dFormat) => {
  if (dateVal === null || dateVal === undefined) {
    return "";
  }
  return moment.utc(dateVal, dFormat?dFormat:"").format(format);
}

const formatPhoneNumber = (number) => {
  const cleaned = (number || "").toString().replace(/\D/g, "").slice(0, 10);
  if (cleaned.length !== 10) return cleaned;
  return `(${cleaned.slice(0, 3)}) ${cleaned.slice(3, 6)} ${cleaned.slice(6, 10)}`;
};

// Purge and reformat any phone number to (999) 999 9999
const purgeAndFormatPhoneNumber = (number) => {
  const cleaned = (number || "").toString().replace(/\D/g, "").slice(0, 10);
  if (cleaned.length !== 10) return cleaned;
  return `(${cleaned.slice(0, 3)}) ${cleaned.slice(3, 6)} ${cleaned.slice(6, 10)}`;
};

// calculate owner price
 const calculateOwnerPrice = (unitCost, quantity, markup, markupType) => {
  const chapterCost = unitCost * quantity
  let result = 0;

  if (markupType === "%") {
      if (markup === 0 || isNaN(markup)) {
          result = chapterCost;
      } else {
          result = (chapterCost * (markup / 100)) + chapterCost;
      }
  } else {
      if (isNaN(markup)) {
          result = chapterCost;
      } else {
          result = Number(chapterCost) + Number(markup);
      }
  }
  return amountFormat(result.toFixed(2))
}


export const commonUtils = {
  debounce,
  greetingFunction,
  capitalize,
  downloadFile,
  amountMask,
  amountMask1,
  amountFormat,
  formatPhoneNumber,
  purgeAndFormatPhoneNumber,
  calculateOwnerPrice,
  formatDate,
  formatAmount
}
